import { IonContent, IonPage, useIonToast, IonLoading, useIonRouter, IonCheckbox, IonLabel, IonAlert, IonIcon } from '@ionic/react';
import CryptoJS from 'crypto-js';
import { eyeOutline, eyeOffOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import logo from '../assets/logo3.png';
import axios from '../axios';
import { AppContext } from '../providers/AppContext';
import { identifyUser, initPostHog } from '../utils/posthogService';


const Login: React.FC = () => {
  const [present] = useIonToast();
  const [showLoading, setShowLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { t, i18n } = useTranslation();
  const url = '/method/preflet_asset.api.get_base_url';

  const [data, setData] = useState<any>({
    usr: '',
    pwd: '',
  });
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const router = useIonRouter();
  const { dispatch, state } = useContext(AppContext);

  const handleChange = (event: any) => {
    const formentry: any = { ...data };
    formentry[event.target.id] = event.target.value.replace(/\s/g, '');
    setData(formentry);
  };

  // const pushNotification = async () => {
  //   try {
  //     const temp = await PushService.checkPushPermission();
  //     if (temp) {
  //       PushService.register();
  //     }
  //   } catch (error: any) {
  //     console.log('error', error);
  //   }
  // };
  useEffect(() => {
    if (localStorage.getItem('remember') === 'true') {
      setChecked(true);
      const usr = CryptoJS.AES.decrypt(localStorage.getItem('username') || '', 'username');
      const pwd = CryptoJS.AES.decrypt(localStorage.getItem('password') || '', 'password');

      const formentry: any = { ...data };
      formentry.usr = usr.toString(CryptoJS.enc.Utf8);
      formentry.pwd = pwd.toString(CryptoJS.enc.Utf8);
      setData(formentry);
    }
    initPostHog();
  }, []);

  const config: any = {
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  };

  const Submit = async (e: any) => {
    e.preventDefault();
    try {
      await axios.get(`${localStorage.getItem('baseUrl') ? localStorage.getItem('baseUrl') : ''}/method/logout`, {
        withCredentials: true,
      });

      // Protect Users Choice
      const temp: boolean = JSON.parse(localStorage.getItem('remember') || 'false');
      // Decrypt the token
      const usr = CryptoJS.AES.decrypt(localStorage.getItem('username') || '', 'username').toString(CryptoJS.enc.Utf8);
      const pwd = CryptoJS.AES.decrypt(localStorage.getItem('password') || '', 'password').toString(CryptoJS.enc.Utf8);
      // Perform the logout
      localStorage.clear();
      sessionStorage.clear();

      // Set Users Choice
      localStorage.setItem('remember', temp + '');
      // Encrypt the token
      const username = CryptoJS.AES.encrypt(usr, 'username').toString();
      const password = CryptoJS.AES.encrypt(pwd, 'password').toString();
      localStorage.setItem('username', username);
      localStorage.setItem('password', password);

      localStorage.setItem('remember', checked + '');


    } catch (e: any) { alert(e.message) /* empty */ }

    localStorage.setItem('baseUrl', state.originalBaseUrl);
    axios.defaults.baseURL = state.originalBaseUrl;
    setShowLoading(true);

    axios(config)
      .then(async (res) => {
        const lang = res?.data?.message?.key_details?.language;
        if (lang === 'en') {
          i18n.changeLanguage('en');
          localStorage.setItem('lang', 'en');
        } else {
          i18n.changeLanguage('pt');
          localStorage.setItem('lang', 'pt');
        }
        localStorage.setItem('fullName', res?.data?.message?.key_details?.full_name);
        localStorage.setItem('email', res?.data?.message?.user);
        const baseUrl = `${res?.data?.message?.base_url}/api`;
        const checkPrezero = baseUrl.includes('prezero');
        localStorage.setItem('isPrezero', checkPrezero ? 'true' : 'false');
        localStorage.setItem('baseUrl', baseUrl);
        axios.defaults.baseURL = baseUrl;

        dispatch({ type: 'loggedIn', payload: res?.data });
        // set permissions
        dispatch({ type: 'permissions', payload: res?.data?.message?.access_level });
        present({
          message: t('Utils.loginS'),
          duration: 2000,
        });
        // pushNotification();

        // Perform login logic
        const distinctId = res?.data?.message?.user; // Replace with the user's distinct ID
        const userProperties = {
          email: res?.data?.message?.user,
          name: res?.data?.message?.key_details?.full_name || res?.data?.message?.user
        };

        // Identify the user
        identifyUser(distinctId, userProperties);

        if (res?.data?.message?.access_level?.home) {
          router.push('/home');
        } else {
          router.push('/survey-home');
        }
      })
      .catch((e) => {
        console.log(e);
        present({
          message: t('Utils.loginWrong'),
          color: 'danger',
          duration: 2000,
        });
      })
      .finally(() => {
        setShowLoading(false);
      });
  };

  const sendEmailLink = async (event: any) => {
    try {
      const email = event[0];
      await axios.post(`/method/preflet_asset.api.reset_password?email=${email}`);
      present({
        message: t('Login.sentEmail'),
        duration: 2000,
      });
    } catch (error: any) {
      console.log('error', error?.response?.data?.exc_type);
      if (error?.response?.data?.exc_type === 'DoesNotExistError') {
        present({
          message: t('Login.notexist'),
          color: 'danger',
          duration: 2000,
        });
      }
    }
  };


  return (
    <IonPage>
      <IonContent className="ion-text-center">
        <img src={process.env.REACT_APP_APP_LOGO || logo} alt="Logo" style={{ maxWidth: '10rem', width: '35%', margin: 'auto', display: 'block', marginTop: '2rem' }}></img>
        <p
          style={{
            fontFamily: 'Nunito Sans Extra-bold, sans-serif',
            color: '#1D508D',
            fontSize: 'xx-large',
            marginTop: '0px',
            fontWeight: 'bolder',
          }}
        >
          <b>{process.env.REACT_APP_APP_NAME || 'Hyprism'}</b>
        </p>
        <p style={{ color: '#1D508D', marginTop: '-10px', fontSize: 'small' }}>{t('Login.Login')}</p>

        <IonLoading

          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={t('Utils.pleasewait')}
          duration={5000}
        />
        <form onSubmit={Submit}>
          <div className="input-container">
            <input
              className="basic-input"
              style={{ padding: '15px' }}
              id="usr"
              required
              placeholder={t('Login.Name')}
              onChange={handleChange}
              value={data.usr}
            />
            <div style={{ position: 'relative', width: '100%' }}>
              <input
                className="basic-input"
                style={{ padding: '15px', width: '100%', paddingRight: '45px' }}
                id="pwd"
                required
                type={showPassword ? "text" : "password"}
                placeholder={t('Login.Pass')}
                onChange={handleChange}
                value={data.pwd}
              />
              <IonIcon
                icon={showPassword ? eyeOffOutline : eyeOutline}
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '15px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  fontSize: '20px',
                  color: '#666',
                  cursor: 'pointer',
                  zIndex: 10
                }}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
              <IonCheckbox
                style={{ marginLeft: '15px', marginRight: '15px' }}
                checked={checked}
                onIonChange={(e) => setChecked(e.detail.checked)}
              />
              <p style={{ color: '#1D508D', fontSize: 'small' }}>{t('Login.Remember')}</p>
            </div>
          </div>
          <button className="submit-button" type="submit">
            {t('Login.L')}
          </button>
        </form>
        <IonLabel onClick={
          () => setShowEmailPopup(true)
        } className='underline' style={{ color: '#1D508D', fontSize: 'small' }}>
          {t('Login.Forgot')}
        </IonLabel>
        <IonAlert
          isOpen={showEmailPopup}
          onDidDismiss={() => setShowEmailPopup(false)}
          header="Enter Email"
          message={'We will send you an email with a link to reset your password.'}
          inputs={[
            {
              type: 'email',
              placeholder: 'Email',
            },
          ]}
          buttons={[
            {
              text: t('Utils.changePassword'),
              handler: (event) => {
                sendEmailLink(event);
              },
            },
          ]}
        ></IonAlert>
      </IonContent>
    </IonPage >
  );
};

export default Login;
